import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const NavMenu = ({ menuWhiteClass, sidebarMenu, scrolled }) => {
  const { t, i18n } = useTranslation();

  const Category = useSelector((state) => state.category);

  const [category, setCategory] = useState([]);
  const [height, setHeight] = useState(0);

  const resizeObserver = new ResizeObserver((entries) => {
    setHeight(entries[0].target.offsetHeight);
  });

  const headerWrapper = document.getElementById("header-wrapper");
  if (headerWrapper) {
    resizeObserver.observe(headerWrapper);
  }

  const filterEnabledCategories = (categories) =>
    categories
      .filter(
        (item) =>
          item.status === "enabled" || item.category?.status === "enabled"
      )
      .reduce((output, item) => {
        const { children, category: subCategory } = item;
        if (Array.isArray(children)) {
          output.push({
            ...item,
            children: filterEnabledCategories(children),
          });
        } else if (Array.isArray(subCategory?.children)) {
          output.push({
            ...item,
            category: {
              ...subCategory,
              children: filterEnabledCategories(subCategory.children),
            },
          });
        } else {
          output.push(item);
        }
        return output;
      }, []);

  useEffect(() => {
    setCategory(filterEnabledCategories(Category));
  }, [Category]);

  useEffect(() => {
    const megaMenu = [...document.getElementsByClassName("mega-menu")];
    if (Array.isArray(megaMenu)) {
      const headerTopAreaHeight = scrolled ? 0 : 90;
      megaMenu.forEach((ele) => {
        Object.assign(ele.style, { top: `${height + headerTopAreaHeight}px` });
      });
    }
  }, [height, scrolled]);

  return (
    <div
      className={` ${
        sidebarMenu ? "sidebar-menu" : `main-menu ${menuWhiteClass || ""}`
      } `}
    >
      <nav>
        <ul>
          {Array.isArray(category) &&
            category.map((item) => (
              <li key={item._id}>
                {Array.isArray(item.children) && item.children.length >= 1 && (
                  <Link
                    to={{
                      pathname: `/browse/${item.slug}`,
                    }}
                  >
                    {getMultiLangProperty(item.name, i18n.language)}
                    {sidebarMenu ? (
                      <span>
                        <i className="fa fa-angle-right" />
                      </span>
                    ) : (
                      <i className="fa fa-angle-down" />
                    )}
                  </Link>
                )}

                {Array.isArray(item.children) && item.children.length === 0 && (
                  <Link
                    to={{
                      pathname: `/browse/${item.slug}`,
                    }}
                  >
                    {getMultiLangProperty(item.name, i18n.language)}
                  </Link>
                )}

                {Array.isArray(item.children) && item.children.length >= 1 && (
                  <ul
                    className={
                      item.children.some(
                        (subItem) =>
                          subItem.category &&
                          Array.isArray(subItem.category.children) &&
                          subItem.category.children.length >= 1
                      )
                        ? "mega-menu mega-menu-padding"
                        : "submenu"
                    }
                  >
                    {Array.isArray(item.children) &&
                      item.children.map((subItem) =>
                        subItem.category ? (
                          <li
                            key={subItem.category._id}
                            className="mega-menu-title"
                          >
                            <Link
                              to={{
                                pathname: `/browse/${subItem.category.slug}`,
                              }}
                            >
                              {getMultiLangProperty(
                                subItem.category.name,
                                i18n.language
                              )}
                            </Link>

                            <ul>
                              {Array.isArray(subItem.category.children) &&
                                subItem.category.children.map(
                                  (thirdSubItem) => (
                                    <li key={thirdSubItem.category._id}>
                                      <Link
                                        to={{
                                          pathname: `/browse/${thirdSubItem.category.slug}`,
                                        }}
                                      >
                                        {getMultiLangProperty(
                                          thirdSubItem.category.name,
                                          i18n.language
                                        )}
                                      </Link>
                                    </li>
                                  )
                                )}
                            </ul>
                          </li>
                        ) : (
                          []
                        )
                      )}
                  </ul>
                )}
              </li>
            ))}

          <li key="blogs">
            <a href="/blogs">{t("home.blogTitle")}</a>
          </li>

          <li key="about">
            <a href="/aboutUs">{t("navMenu.aboutUs")}</a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
  strings: PropTypes.object,
};

export default NavMenu;
